import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from "@app/shared/components";


@Component({
    selector: 'app-photo-carousel',
    templateUrl: './photo-carousel.component.html',
    styleUrls: ['./photo-carousel.component.scss']
})
export class PhotoCarouselComponent implements AfterViewInit {
    @ViewChild('modal', {static: false}) modal: ModalComponent;

    @Input() photos: { id: number, url: string }[] = [];
    @Input() headerText = '';
    @Input() numVisibleItems = 1;
    @Input() circular = false;
    @Input() canDelete = true;

    @Output() deletePhoto = new EventEmitter<any>();

    selectedPhoto: any;

    constructor(private sanitizer: DomSanitizer) {
    }

    public ngAfterViewInit(): void {
    }

    getSanitizedUrl(url: string) {
        if (!url) {
            return null;
        }
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    removePhoto(event: any, photo: any) {
        event.preventDefault();
        event.stopPropagation();

        const removedPhoto = this.photos.find(item => item.id === photo.id);
        this.deletePhoto.emit(removedPhoto);
    }

    showPhoto(event: any, photo: string) {
        event.preventDefault();
        event.stopPropagation();

        this.selectedPhoto = photo;
        this.modal.open();
    }

    closeModal() {
        this.modal.close();
    }
}
